import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import SettingSidebar from '../layouts/SettingsSidebar'
import Select from "react-select";

import FeatherIcon from 'feather-icons-react';
import Header from '../layouts/Header'
import Sidebar from '../layouts/Sidebar'
// import { useFormik } from "formik";
import { useFormik, FormikProvider } from "formik";
import axios from "../api/axios";
import { Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION, AWS_BUCKET } from "../Global";

const ProfileSettings = () => {
  let { id } = localStorage.getItem('auth_id');

  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
  const [locationLoading, setLocationLoading] = useState([]);
   
  const formik = useFormik({
    initialValues: {
      id: value.id,
      first_name: value.first_name,
      last_name: value.last_name,
      email: value.email,
      phone_number: value.phone_number,
      user_location: value.user_location,
      user_position: value.user_position,
      profile_path: value.profile_path,
      profile_picture: value.profile_picture,
      status: value.status,
      role: value.role_id,
      company_name: value.customer_id
    },
    enableReinitialize: true,
    // validationSchema: EditUserSchema,
    onSubmit: (values, actions) => {
      axios
        .post("/users/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          delete backendErrors['error'];
          actions.setSubmitting(false);

          if (response.data.code === 200) {
            toast.success(response.data.message);
            actions.resetForm();
            localStorage.setItem("profile_image", response.data.data.user.profile_picture);
            //return false;
            setTimeout(() => {
              window.location.href = "/update-profile";
            }, 1000);
          } else if (response.data.code === 422) {
            setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
            setBackendErrors(response.data.error);
          }
        }).catch((error) => {
          console.log(error);
          actions.setSubmitting(false);
        });
    },
  });

  useEffect(() => {
    var auth_profile_image = '';
    axios
      .get(`/users/edit/${localStorage.getItem('auth_id')}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          //toast.error(response.data.data.user);
          var user_data = response.data.data.user;
          setValue(user_data);
          
          AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
          AWS.config.update({
            accessKeyId: AWS_ACCESS_KEY_ID,
            secretAccessKey: AWS_SECRET_ACCESS_KEY,
            region: AWS_DEFAULT_REGION,
            signatureVersion: 'v4',
          });
          const s3 = new AWS.S3();
          var params = {Bucket: AWS_BUCKET, Key: user_data.profile_picture};
          auth_profile_image = s3.getSignedUrl('getObject', params);
          user_data.profile_picture = auth_profile_image;
          setValue(user_data);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`/helpers/loading-locations`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let productslisting = response.data.data.locations;
          let locations = productslisting.map((customer, index) => ({
            label: customer.title,
            value: customer.id,
            key: `farmer-${index}`,
          }));
          setLocationLoading(locations);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const customHandleInput = (event) => {
    const Input_name = event.name;
    delete backendErrors[Input_name];
  };

  const toggleMobileMenu = () => {
    setMenu(!menu)
  }
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };
  return (
    <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}> 
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar /> 	<ToastContainer />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-6">
                <h3 className="page-title">Update Profile</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"><Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Update Profile</li>
                </ul>
              </div>
            </div>
          </div>
        
          <div className="row">
            <div className="col-xl-2 col-md-3">
              <SettingSidebar />
            </div>
            
            <div className="col-xl-10 col-md-9">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">User Information</h5>
                </div>
                <div className="card-body">
                   <FormikProvider value={formik}>
                   <form action="#" onSubmit={formik.handleSubmit}>
                    <div className="row justify-content-lg-center">
                      <div className="col-lg-10">
                        <div className="text-center py-5">
                          <label
                            className="avatar avatar-xxl profile-cover-avatar"
                            htmlFor="avatar_upload"
                          >
                            <input
                              type="file"
                              id="avatar_upload"
                              onChange={(event) => {
                                const file = event.target.files[0];
                                const reader = new FileReader();

                                reader.onloadend = () => {
                                  const profile_picture = reader.result;
                                  formik.handleChange({
                                    target: {
                                      name: "profile_picture",
                                      value: profile_picture,
                                    },
                                  });
                                };

                                if (file) {
                                  reader.readAsDataURL(file);
                                }
                              }}
                            />

                            <img className="avatar-img" src={formik.values.profile_picture} alt="Profile Image"/>
                            <span className="avatar-edit">
                              <FeatherIcon
                                icon="edit-2"
                                className="avatar-uploader-icon shadow-soft"
                              />
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>First Name</label>
                          <input
                            type="text"
                            name="first_name"
                            value={formik.values.first_name}
                            className="form-input form-control"
                            onChange={(e) => {
                              formik.handleChange(e);
                              customHandleInput(e);
                            }}
                            onBlur={formik.handleBlur}
                          />
                          <small>
                            {backendErrors.first_name && (
                              <span className="form-error mt-1">
                                {backendErrors.first_name}
                              </span>
                            )}
                          </small>
                        </div>
                        <div className="form-group">
                          <label>Email</label>
                          <input
                            type="text"
                            value={formik.values.email}
                            name="email" readOnly
                            className= "form-input form-control"
                         
                            onChange={(e) => {
                              formik.handleChange(e);
                              customHandleInput(e);
                            }}
                            onBlur={formik.handleBlur}
                          />
                          <small>
                            {backendErrors.email && (
                              <span className="form-error mt-1">
                                {backendErrors.email}
                              </span>
                            )}
                          </small>
                        </div>
                        {value.role_id !=3 && (
                          <div className="form-group status">
                          <label>Location</label>
                          {locationLoading.length > 0 && (
                            <Select
                            className="w-100"
                            value={locationLoading.find(option => option.value == formik.values.user_location) || null} // Ensure correct format
                            name="user_location"
                            onChange={(selectedOption) => {
                            handleSelectChange("user_location", selectedOption);
                           
                            }}
                            onBlur={formik.handleBlur}
                            options={locationLoading}
                            placeholder="Select"

                            />
                          )}
                          
                          <small>
                            {backendErrors.user_location && (
                              <span className="form-error mt-1">
                                {backendErrors.user_location}
                              </span>
                            )}
                          </small>
                        </div>
                        )}
                        
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Last Name</label>
                          <input
                            type="text"
                            value={formik.values.last_name}
                            name="last_name"
                            className="form-input form-control"
                             onChange={(e) => {
                              formik.handleChange(e);
                              customHandleInput(e);
                            }} 
                            onBlur={formik.handleBlur}
                          />
                          <small>
                            {backendErrors.last_name && (
                              <span className="form-error mt-1">
                                {backendErrors.last_name}
                              </span>
                            )}
                          </small>
                        </div>
                        <div className="form-group">
                          <label>Phone</label>
                          <input
                            type="text"
                            value={formik.values.phone_number}
                            name="phone_number"
                            className= "form-input form-control"
                            onChange={(e) => {
                              formik.handleChange(e);
                              customHandleInput(e);
                            }}
                            onBlur={formik.handleBlur}
                          />
                          <small>
                            {backendErrors.phone_number && (
                              <span className="form-error mt-1">
                                {backendErrors.phone_number}
                              </span>
                            )}
                          </small>
                        </div>
                        {value.role_id !=3 && (
                          <div className="form-group">
                          <label>Position</label>
                          <input
                            type="text"
                            value={formik.values.user_position}
                            name="user_position"
                            className= "form-input form-control"
                            onChange={(e) => {
                              formik.handleChange(e);
                              customHandleInput(e);
                            }}
                            onBlur={formik.handleBlur}
                          />
                          <small>
                            {backendErrors.user_position && (
                              <span className="form-error mt-1">
                                {backendErrors.user_position}
                              </span>
                            )}
                          </small>
                        </div>
                        )}
                      
                      </div>
                    </div>
                    <small>
                      
                      {backendErrors.status && (
                        <span className="form-error mt-1">
                          {backendErrors.status}
                        </span>
                      )}
                    </small>
                    <div className="text-end mt-4">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={formik.isSubmitting}
                      >
                        Update
                      </button>
                    </div>
                  </form>
                   </FormikProvider>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>		
  );
}

export default ProfileSettings;